import React, { useState, useEffect } from "react";
import MapSection from "./MapSection";
import Footer from "./Footer";
import Modal from "./Modal";
import BuildingChart from "./BuildingChart";
import "./Main.css";
import "./Header.css";
import API_URL from "./config";
import { useAuth } from "../App";

import Image1 from "../assets/img/image 1.png";
import Image2 from "../assets/img/image 2.png";
import Image3 from "../assets/img/image 3.png";
import Perehod from "../assets/img/perehod2.svg";
import ProfileIcon from "../assets/img/profile-icon.svg";

// Список адресов для выпадающего списка в секции прогноза
const BUILDING_ADDRESSES = [
  { id: 98, address: "ул. Анисимова, 5, Норильск, Красноярский край" },
  { id: 120, address: "ул. Бегичева, 13, Норильск, Красноярский край" },
  { id: 249, address: "ул. Кирова, 2, Норильск, Красноярский край" },
  { id: 6, address: "Котульского проезд, 2, Норильск, Красноярский край" },
  { id: 53, address: "пр-кт Ленинский, 27 к1, Норильск, Красноярский край" },
  { id: 907, address: "пр-кт Ленинский, 27 к2, Норильск, Красноярский край" },
  { id: 27, address: "пл. Металлургов, 17, Норильск, Красноярский край" },
  { id: 946, address: "ул. Орджоникидзе, 10 с4, Норильск, Красноярский край" },
  { id: 578, address: "ул. Орджоникидзе, 7, Норильск, Красноярский край" },
  { id: 955, address: "ул. Талнахская, 10 к2, Норильск, Красноярский край" },
  { id: 771, address: "ул. Талнахская, 78, Норильск, Красноярский край" }
];

function Main() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const { isAuthenticated, userRole } = useAuth();
  const [houses, setHouses] = useState([]); // Храним список домов
  const [selectedBuildingId, setSelectedBuildingId] = useState(null);
  const [selectedBuildingAddress, setSelectedBuildingAddress] = useState(null);
  const [selectedBuildingDetails, setSelectedBuildingDetails] = useState(null); // Для хранения подробных данных о выбранном доме

  const fetchHouses = async (seriesFilter = null) => {
    try {
      const token = localStorage.getItem("access_token");
      if (!token) return;
  
      // Используем новый эндпоинт для оптимизированной загрузки данных
      let url = `${API_URL}/House/houses-map`;
      
      // Если выбрана конкретная серия (не "Все серии"), добавляем параметр для фильтрации
      if (seriesFilter && seriesFilter !== 'Все серии') {
        // Проверяем, является ли seriesFilter массивом
        if (Array.isArray(seriesFilter)) {
          // Если это массив, добавляем каждый элемент как отдельный параметр series
          const params = new URLSearchParams();
          seriesFilter.forEach(series => {
            params.append('series', series);
          });
          url += `?${params.toString()}`;
        } else {
          // Если это строка, добавляем один параметр
          url += `?series=${encodeURIComponent(seriesFilter)}`;
        }
      }
  
      const response = await fetch(url, {
        method: "GET",
        headers: { "Authorization": `Bearer ${token}` },
        credentials: "include",
      });
  
      if (response.ok) {
        const data = await response.json();
        setHouses(data.features);
      }
    } catch (error) {
      console.error("Ошибка загрузки домов:", error);
    }
  };
  
  // Новый метод для загрузки подробных данных о доме по ID
  const fetchHouseById = async (houseId) => {
    try {
      const token = localStorage.getItem("access_token");
      if (!token || !houseId) return;
      
      const url = `${API_URL}/House/gethouse_by_id/${houseId}`;
      
      const response = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });
      
      if (response.ok) {
        const data = await response.json();
        setSelectedBuildingDetails(data);
        // Обновляем также адрес здания из полученных данных
        if (data && data.properties) {
          setSelectedBuildingAddress(data.properties.address);
        }
      }
    } catch (error) {
      console.error("Ошибка загрузки данных о доме:", error);
    }
  };

  // Функции проверки доступа по ролям
  const canAccessMap = () => isAuthenticated && userRole >= 1;
  const canAccessAnalytics = () => isAuthenticated && userRole >= 2;
  const canAccessForecast = () => isAuthenticated && userRole >= 3;
  const canAccessAdmin = () => isAuthenticated && userRole === 4;

  useEffect(() => {
    // Если пользователь авторизован, загружаем данные домов
    if (isAuthenticated) {
      fetchHouses(null);
    }
    
    // Восстанавливаем позицию прокрутки после возврата с полноэкранного чат-бота
    const restoreScrollPosition = () => {
      const savedPosition = sessionStorage.getItem('chatbot_return_position');
      if (savedPosition) {
        setTimeout(() => {
          window.scrollTo({
            top: parseInt(savedPosition),
            behavior: 'instant'
          });
          sessionStorage.removeItem('chatbot_return_position');
        }, 50);
      }
    };
    
    restoreScrollPosition();
  }, [isAuthenticated]);
  
  const openModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleLoginSuccess = async () => {
    // После успешного входа просто закрываем модальное окно,
    // обновление состояния авторизации будет выполнено в Modal.js
    closeModal();
  };

  const scrollToMap = () => {
    const mapSection = document.getElementById("map");
    if (mapSection) {
      mapSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Источник отчёта Power BI (только для светлой темы)
  const powerBISrc = "https://app.powerbi.com/view?r=eyJrIjoiMjZkYTVhYzctZTBiYy00YmQxLWIwNTUtMGRkZWYxZjhiNjljIiwidCI6ImU0YTFjYTRmLTFmNTktNDdhZS1iOTMzLWFlOTBkNzJlY2Q2MiIsImMiOjl9";

  // Обработчик выбора здания - обновляем ID и загружаем детальные данные
  const handleSelectBuilding = (buildingId) => {
    setSelectedBuildingId(buildingId);
    
    // Находим дом по ID в списке базовых данных и сначала устанавливаем его адрес
    if (houses && houses.length > 0) {
      const selectedHouse = houses.find(house => house.properties.id === buildingId);
      if (selectedHouse) {
        setSelectedBuildingAddress(selectedHouse.properties.address);
      }
    }
    
    // Загружаем подробные данные о доме по ID
    fetchHouseById(buildingId);
    
    // Автоматическая прокрутка к секции прогноза отключена
    // if (canAccessForecast()) {
    //   scrollToForecast();
    // }
  };

  // Обработчик изменения серии дома
  const handleSeriesChange = (series) => {
    fetchHouses(series);
  };

  // Отладочная информация при рендеринге
  useEffect(() => {
    if (isAuthenticated) {
      console.log("Рендеринг: пользователь авторизован, роль:", userRole);
    }
  }, [isAuthenticated, userRole]);

  return (
    <div className="main">
      <header className="header">
        <div className="header-container">
          <h1 className="header-title">
            <button type="button" className="logo-link" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Nordhouse</button>
          </h1>
          
          <nav>
            <ul className="header-nav">
              {canAccessMap() && (
                <li className="header-nav-item">
                  <a href="#map">Карта</a>
                </li>
              )}
              {canAccessAnalytics() && (
                <li className="header-nav-item">
                  <a href="#analytics">Аналитика</a>
                </li>
              )}
              {canAccessForecast() && (
                <li className="header-nav-item">
                  <a href="#forecast">Прогноз</a>
                </li>
              )}
              {canAccessAdmin() && (
                <li className="header-nav-item">
                  <a href="/admin">Админ</a>
                </li>
              )}
            </ul>
          </nav>
          <div className="header-buttons">
            {isAuthenticated ? (
              <a href="/profile" className="header-profile-link" title="Личный кабинет">
                <img src={ProfileIcon} alt="Личный кабинет" className="profile-icon" />
                </a>
            ) : (
              <button className="header-login-btn" onClick={openModal}>Войти</button>
            )}
          </div>
        </div>
      </header>

      {/* Секция с баннером - видна всем пользователям */}
      <section className="feedback-space">
        <div className="feedback-container">
          <div className="feedback-gradient"></div>
          <div className="feedback-image-wrapper">
            <div className="feedback-image"></div>
          </div>
          <div className="feedback-content">
            <h2>NORDHOUSEMAP</h2>
            <p>Интерактивная карта состояния жилого фонда Норильска</p>
            {canAccessMap() ? (
              <button className="feedback-button" onClick={scrollToMap}>
                ПЕРЕЙТИ К КАРТЕ
              </button>
            ) : (
              <button className="feedback-button" onClick={openModal}>
                ВОЙТИ ДЛЯ ДОСТУПА
              </button>
            )}
          </div>
        </div>
      </section>

      {/* Секция с карточками - видна всем пользователям */}
      <div className="hero-section">
        <div className="hero-header">
          <h2>Что мы предлагаем?</h2>
          <p>Инструмент, который помогает жителям, инвесторам и муниципальным службам принимать обоснованные решения о жилье в Норильске.</p>
        </div>

        <div className="hero-content">
          <div className="hero-card">
            <img src={Image1} alt="Подробная информация о каждом доме" />
            <div className="text-content">
              <h3>Подробная информация о каждом доме</h3>
              <p>Уровень износа, техническое состояние, год постройки и капремонта.</p>
            </div>
          </div>

          <div className="hero-card">
            <img src={Image2} alt="Удобный доступ к данным" />
            <div className="text-content">
              <h3>Удобный доступ к данным</h3>
              <p>Визуализация на интерактивной карте, фильтры по районам и параметрам.</p>
            </div>
          </div>

          <div className="hero-card">
            <img src={Image3} alt="Прозрачность и актуальность" />
            <div className="text-content">
              <h3>Прозрачность и актуальность</h3>
              <p>Информация обновляется, чтобы вы всегда были в курсе.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Разделитель - виден только авторизованным пользователям */}
      {isAuthenticated && (
        <div className="perehod-wrapper">
          <img src={Perehod} alt="Разделитель" className="perehod-image img-accessibility" />
        </div>
      )}

      {/* Секция с картой - видна только авторизованным пользователям */}
      {canAccessMap() && (
        <MapSection
          houses={houses}
          onSelectBuilding={handleSelectBuilding}
          onSeriesChange={handleSeriesChange}
          selectedBuildingDetails={selectedBuildingDetails}
          userRole={userRole}
        />
      )}

      {/* Разделитель перед аналитикой */}
      {canAccessAnalytics() && (
        <div className="perehod-wrapper">
          <img src={Perehod} alt="Разделитель" className="perehod-image img-accessibility" />
        </div>
      )}

      {/* Секция с аналитикой - видна пользователям с ролью 2 и выше */}
      {canAccessAnalytics() && (
        <div className="analytics-section" id="analytics">
          <h2 className="analytics-title">Аналитика</h2>

          <p className="analytics-description">
            Интерактивные графики Power BI предоставляют данные о состоянии жилого фонда.
          </p>
          <div className="analytics-container">
            {!fadeOut && (
              <div className="analytics-loader">
                <div className="analytics-spinner"></div>
              </div>
            )}
            <iframe
              src={powerBISrc}
              title="Power BI Analytics"
              className={`analytics-iframe ${fadeOut ? "fade-out" : ""}`}
              onLoad={() => setTimeout(() => setFadeOut(true), 500)}
              width="100%"
              height="600px"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}

      {/* Разделитель перед прогнозом */}
      {canAccessForecast() && (
        <div className="perehod-wrapper">
          <img src={Perehod} alt="Разделитель" className="perehod-image img-accessibility" />
        </div>
      )}

      {/* Секция прогноза - отображается только для пользователей с ролями 3 и 4 */}
      {canAccessForecast() && (
        <section className="building-chart-section" id="forecast">
          <h2>ПРОГНОЗ ПО ЗДАНИЮ</h2>
          <div className="forecast-header">
            <div className="forecast-title-block">
            <p className="building-chart-address">
            ПРОГНОЗ ДАТЧИКОВ ТЕМПЕРАТУРЫ
          </p>
            </div>
            <div className="forecast-building-selector">
              <select
                value={selectedBuildingId || ""}
                onChange={(e) => {
                  const newBuildingId = e.target.value;
                  setSelectedBuildingId(newBuildingId);
                  
                  // Обновляем адрес здания при изменении выбора
                  if (newBuildingId) {
                    const selected = BUILDING_ADDRESSES.find(b => b.id === parseInt(newBuildingId));
                    if (selected) {
                      setSelectedBuildingAddress(selected.address);
                    }
                  }
                  
                  // Загружаем детальные данные о здании
                  if (newBuildingId) {
                    fetchHouseById(newBuildingId);
                  }
                }}
                className="forecast-building-select"
              >
                <option value="">Выберите здание</option>
                {BUILDING_ADDRESSES.map(building => (
                  <option key={building.id} value={building.id}>
                    {building.address}
                  </option>
                ))}
              </select>
            </div>
          </div>
            <BuildingChart 
              buildingId={selectedBuildingId} 
              buildingAddress={selectedBuildingAddress}
              buildingDetails={selectedBuildingDetails}
            showSelector={false}
            />
        </section>
      )}

      {/* Футер - виден всем пользователям */}
      <Footer />

      {isModalOpen && <Modal closeModal={closeModal} onLoginSuccess={handleLoginSuccess} />}

    </div>
  );
}

export default Main;